import styles from '../shared/mhlShared.module.scss'
import localStyles from './MilitaryHearingLossWebsiteVisitors.module.scss'
import { Pill } from '../shared/SourceTabs'
import type { VisitorSourceStats } from '../shared/mhlTypes'
import { referralLabel, referralTone, UNKNOWN_REFERRAL } from '../shared/mhlFormatting'

interface Props {
    rows: VisitorSourceStats[]
    loading: boolean
    /** Current page-wide source filter ('all' or a source). */
    selected: string
    onSelect: (source: string) => void
}

/** Visitors, page loads and signups per referral source for the period. Click a row to filter the page by it. */
export const SourceBreakdownTable = ({ rows, loading, selected, onSelect }: Props) => (
    <>
        <div className={styles.tableWrap}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Source</th>
                        <th className="num">Unique visitors</th>
                        <th className="num">Page loads</th>
                        <th className="num">Webform signups</th>
                        <th className="num">Conversion</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && rows.length === 0 ? (
                        <tr>
                            <td colSpan={5} className={styles.emptyState}>
                                Loading…
                            </td>
                        </tr>
                    ) : rows.length === 0 ? (
                        <tr>
                            <td colSpan={5} className={styles.emptyState}>
                                No visits recorded in this period.
                            </td>
                        </tr>
                    ) : (
                        rows.map((row) => {
                            // Unknown has no filter value: those visits predate source tagging.
                            const filterable = row.source !== UNKNOWN_REFERRAL
                            const active = selected === row.source
                            return (
                                <tr
                                    key={row.source}
                                    className={`${filterable ? styles.rowClickable : ''} ${active ? localStyles.rowSelected : ''}`}
                                    onClick={filterable ? () => onSelect(active ? 'all' : row.source) : undefined}
                                    title={filterable ? (active ? 'Show all sources' : `Show only ${referralLabel(row.source)}`) : undefined}
                                >
                                    <td>
                                        <Pill tone={referralTone(row.source)} dot>
                                            {referralLabel(row.source)}
                                        </Pill>
                                    </td>
                                    <td className="num">{row.visitors.toLocaleString()}</td>
                                    <td className="num">{row.pageviews.toLocaleString()}</td>
                                    <td className="num">{row.webformSignups.toLocaleString()}</td>
                                    <td className="num">{row.conversionRate}%</td>
                                </tr>
                            )
                        })
                    )}
                </tbody>
            </table>
        </div>
        <p className={localStyles.sectionNote} style={{ marginTop: 10 }}>
            "Unknown" is traffic from before source tracking went live. Click a source to filter the page by it.
        </p>
    </>
)
